/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { CreateOpportunityTemplateDto } from "../types/createOpportunityTemplateDto";

import type { ListOpportunityTemplatesParams } from "../types/listOpportunityTemplatesParams";

import type { ListSystemTemplatesParams } from "../types/listSystemTemplatesParams";

import type { OpportunityTemplateDto } from "../types/opportunityTemplateDto";

import type { OpportunityTemplateDtoPaginatedResult } from "../types/opportunityTemplateDtoPaginatedResult";

import type { ProblemDetails } from "../types/problemDetails";

import type { UpdateOpportunityTemplateDto } from "../types/updateOpportunityTemplateDto";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * **Required Permission(s):** ORG_OPP_TEMPLATE_LIST
 */
export const listOpportunityTemplates = (
  params?: ListOpportunityTemplatesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OpportunityTemplateDtoPaginatedResult>> => {
  return axios.default.get(`/api/opportunity-templates`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListOpportunityTemplatesQueryKey = (
  params?: ListOpportunityTemplatesParams,
) => {
  return [`/api/opportunity-templates`, ...(params ? [params] : [])] as const;
};

export const getListOpportunityTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listOpportunityTemplates>>,
  TError = AxiosError<void>,
>(
  params?: ListOpportunityTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOpportunityTemplates>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOpportunityTemplatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOpportunityTemplates>>
  > = ({ signal }) =>
    listOpportunityTemplates(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOpportunityTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOpportunityTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOpportunityTemplates>>
>;
export type ListOpportunityTemplatesQueryError = AxiosError<void>;

export function useListOpportunityTemplates<
  TData = Awaited<ReturnType<typeof listOpportunityTemplates>>,
  TError = AxiosError<void>,
>(
  params?: ListOpportunityTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOpportunityTemplates>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListOpportunityTemplatesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_OPP_TEMPLATE_CREATE
 */
export const createOpportunityTemplate = (
  createOpportunityTemplateDto: CreateOpportunityTemplateDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OpportunityTemplateDto>> => {
  return axios.default.post(
    `/api/opportunity-templates`,
    createOpportunityTemplateDto,
    options,
  );
};

export const getCreateOpportunityTemplateMutationOptions = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOpportunityTemplate>>,
    TError,
    { data: CreateOpportunityTemplateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOpportunityTemplate>>,
  TError,
  { data: CreateOpportunityTemplateDto },
  TContext
> => {
  const mutationKey = ["createOpportunityTemplate"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOpportunityTemplate>>,
    { data: CreateOpportunityTemplateDto }
  > = (props) => {
    const { data } = props ?? {};

    return createOpportunityTemplate(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOpportunityTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOpportunityTemplate>>
>;
export type CreateOpportunityTemplateMutationBody =
  CreateOpportunityTemplateDto;
export type CreateOpportunityTemplateMutationError =
  AxiosError<ProblemDetails | void>;

export const useCreateOpportunityTemplate = <
  TError = AxiosError<ProblemDetails | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOpportunityTemplate>>,
    TError,
    { data: CreateOpportunityTemplateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof createOpportunityTemplate>>,
  TError,
  { data: CreateOpportunityTemplateDto },
  TContext
> => {
  const mutationOptions = getCreateOpportunityTemplateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const listSystemTemplates = (
  params?: ListSystemTemplatesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OpportunityTemplateDtoPaginatedResult>> => {
  return axios.default.get(`/api/opportunity-templates/system`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListSystemTemplatesQueryKey = (
  params?: ListSystemTemplatesParams,
) => {
  return [
    `/api/opportunity-templates/system`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListSystemTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSystemTemplates>>,
  TError = AxiosError<unknown>,
>(
  params?: ListSystemTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSystemTemplates>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSystemTemplatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSystemTemplates>>
  > = ({ signal }) => listSystemTemplates(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSystemTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSystemTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSystemTemplates>>
>;
export type ListSystemTemplatesQueryError = AxiosError<unknown>;

export function useListSystemTemplates<
  TData = Awaited<ReturnType<typeof listSystemTemplates>>,
  TError = AxiosError<unknown>,
>(
  params?: ListSystemTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSystemTemplates>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSystemTemplatesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_OPP_TEMPLATE_GET
 */
export const getOpportunityTemplateById = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OpportunityTemplateDto>> => {
  return axios.default.get(`/api/opportunity-templates/${id}`, options);
};

export const getGetOpportunityTemplateByIdQueryKey = (id?: string) => {
  return [`/api/opportunity-templates/${id}`] as const;
};

export const getGetOpportunityTemplateByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getOpportunityTemplateById>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOpportunityTemplateById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOpportunityTemplateByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOpportunityTemplateById>>
  > = ({ signal }) =>
    getOpportunityTemplateById(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOpportunityTemplateById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOpportunityTemplateByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOpportunityTemplateById>>
>;
export type GetOpportunityTemplateByIdQueryError =
  AxiosError<void | ProblemDetails>;

export function useGetOpportunityTemplateById<
  TData = Awaited<ReturnType<typeof getOpportunityTemplateById>>,
  TError = AxiosError<void | ProblemDetails>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOpportunityTemplateById>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOpportunityTemplateByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Required Permission(s):** ORG_OPP_TEMPLATE_UPDATE
 */
export const updateOpportunityTemplate = (
  id: string,
  updateOpportunityTemplateDto: UpdateOpportunityTemplateDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OpportunityTemplateDto>> => {
  return axios.default.put(
    `/api/opportunity-templates/${id}`,
    updateOpportunityTemplateDto,
    options,
  );
};

export const getUpdateOpportunityTemplateMutationOptions = <
  TError = AxiosError<void | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOpportunityTemplate>>,
    TError,
    { id: string; data: UpdateOpportunityTemplateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOpportunityTemplate>>,
  TError,
  { id: string; data: UpdateOpportunityTemplateDto },
  TContext
> => {
  const mutationKey = ["updateOpportunityTemplate"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOpportunityTemplate>>,
    { id: string; data: UpdateOpportunityTemplateDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateOpportunityTemplate(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOpportunityTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOpportunityTemplate>>
>;
export type UpdateOpportunityTemplateMutationBody =
  UpdateOpportunityTemplateDto;
export type UpdateOpportunityTemplateMutationError =
  AxiosError<void | ProblemDetails>;

export const useUpdateOpportunityTemplate = <
  TError = AxiosError<void | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOpportunityTemplate>>,
    TError,
    { id: string; data: UpdateOpportunityTemplateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateOpportunityTemplate>>,
  TError,
  { id: string; data: UpdateOpportunityTemplateDto },
  TContext
> => {
  const mutationOptions = getUpdateOpportunityTemplateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Required Permission(s):** ORG_OPP_TEMPLATE_DELETE
 */
export const deleteOpportunityTemplate = (
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.default.delete(`/api/opportunity-templates/${id}`, options);
};

export const getDeleteOpportunityTemplateMutationOptions = <
  TError = AxiosError<void | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOpportunityTemplate>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOpportunityTemplate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteOpportunityTemplate"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOpportunityTemplate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteOpportunityTemplate(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOpportunityTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOpportunityTemplate>>
>;

export type DeleteOpportunityTemplateMutationError =
  AxiosError<void | ProblemDetails>;

export const useDeleteOpportunityTemplate = <
  TError = AxiosError<void | ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOpportunityTemplate>>,
    TError,
    { id: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteOpportunityTemplate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteOpportunityTemplateMutationOptions(options);

  return useMutation(mutationOptions);
};
